import React, { useEffect, useState } from 'react';
import { useWebSocket, sendWebSocketMessage } from '../hooks/useWebSocket';
import { useAuth } from '../hooks/useAuth';
import { WS_URL } from '../config';
import SongTable from '../components/SongTable';
import { Link } from 'react-router-dom';

export default function QueuePage() {
  const { authToken } = useAuth();
  const data = useWebSocket(WS_URL);
  const [recentComments, setRecentComments] = useState([]);

  useEffect(() => {
    // Scroll to top on mount
    window.scrollTo({ top: 0, behavior: 'smooth' });
    sendWebSocketMessage({ type: 'refresh' });
  }, []);

  useEffect(() => {
    fetch('/api/comments/recent')
      .then(res => res.json())
      .then(data => setRecentComments(data.comments || []))
      .catch(err => console.error('❌ Failed to fetch recent comments:', err));
  }, []);

  if (!data || data.type !== 'playback_update') {
    return <div className="p-4">⏳ Loading queue...</div>;
  }

  const now = { ...data.now_playing, source: 'now', isNowPlaying: true };
  const upcoming = [...data.queue].reverse().map(song => ({ ...song, source: 'upcoming' }));
  const history = (data.history ? data.history.slice(0) : []).map(song => ({ ...song, source: 'history' }));
  const enrichedSongs = [...upcoming, now, ...history];

  return (
    <div className="p-4 space-y-6">
      <div className="overflow-x-auto w-full">
        <SongTable songs={enrichedSongs} showTime showFavorites sortable={false} />
      </div>

      {recentComments.length > 0 && (
        <div className="mt-8">
          <h2 className="text-xl font-semibold mb-2">
            <img src="/emoji/1F4AC.svg" alt="Recent Comments" className="inline w-6 h-6 mr-1 align-text-bottom" />
            Recent Comments
          </h2>
          <ul className="space-y-3">
            {recentComments.map(({ comment, username, created_at, song }) => (
              <li key={`${song.id}-${created_at}`} className="border p-3 rounded shadow-sm bg-white">
                <div className="text-sm text-gray-500">
                  <Link to={`/song/${song.id}`} className="text-blue-600 hover:underline">
                    {song.artist} – {song.title}
                  </Link>
                  <span className="ml-2">by <strong>{username}</strong></span>
                  <span className="ml-2 text-xs text-gray-400">
                    {new Date(created_at * 1000).toLocaleString()}
                  </span>
                </div>
                <div className="mt-1 text-gray-800">{
                  comment.split('\n').map((line, i) => (
                    <React.Fragment key={i}>
                      {line}
                      {i < comment.split('\n').length - 1 && <br />}
                    </React.Fragment>
                  ))
                }</div>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
